import { useEffect, useState } from "react";
import axios from "axios";
import { withAuthHeader } from "../domains/auth/authentication.service";

// <img> tags can't send the app's Bearer token, so protected photo URLs need to be fetched via axios and rendered as a blob URL.
export function useAuthenticatedImageSrc(url: string, enabled: boolean = true): string {
  const [objectUrl, setObjectUrl] = useState<string>(null);

  useEffect(() => {
    let cancelled = false;
    let createdUrl: string = null;

    if (!url || !enabled) {
      setObjectUrl(null);
      return undefined;
    }

    (async () => {
      try {
        const headers = await withAuthHeader();
        const response = await axios.get(url, { headers, responseType: "blob" });
        if (cancelled) return;
        createdUrl = URL.createObjectURL(response.data);
        setObjectUrl(createdUrl);
      } catch (e) {
        if (!cancelled) setObjectUrl(null);
      }
    })();

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url, enabled]);

  return objectUrl;
}
